// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module_container__oIzQdIC9T3Kw9mlmgpew","spacer":"style-module_spacer__Mjw3QpwWPhoTzLJxL5lk"};